import AutocompleteComponent from "@/components/commons/autocomplete/AutocompleteComponent.vue";
import { enterpriseService } from '@/services/enterprise.service';
import { generalConfigurationService } from '@/services/generalConfiguration.service';

export default {
    name: 'EnterpriseDataTabComponent',
    components: {
        AutocompleteComponent
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        validForm: {
            type: Boolean,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        },
        update: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model para el formulario
        isValidForm: false,
        // actualName
        actualName: null,
        // mensajes de error para el nombre de empresa
        nameError: [],
        // modelo para el selector de hora
        timeMenu: false,
        legalPersonTypes: [],
        maskValidator: [],
        isCuit: false,
        isCnpj: false,
    }),
    computed: {
    },
    async created() {
        this.actualName = this.model.name;
        this.legalPersonTypes.cleanAndUpdate(await generalConfigurationService.getLegalPersonTypes());
    },
    mounted() {
        if (!this.model.legalPersonType) {
            this.model.legalPersonType = 'CUIT';
        }
        this.setLegalPersonMask();
    },
    methods: {
        setLegalPersonMask() {
            this.isCuit = false;
            this.isCnpj = false;
            if (this.model.legalPersonType === 'CUIT') {
                this.isCuit = true;
            } else if (this.model.legalPersonType === 'CNPJ') {
                this.isCnpj = true;
            }
        },
        legalPersonChanged(event) {
            if (event.id) {
                this.model.legalPersonType = event.id;
                this.setLegalPersonMask();
                this.$refs.enterpriseDataForm.validate();
            }
        },
        /**
         * Validación de nombre duplicado
         */
        duplicatedEnterpriseNameValidation() {
            if (this.model.name === this.actualName) return
            enterpriseService.validateName(this.model.name).then(value => {
                if (value) {
                    this.nameError.push(this.$t('enterprise.duplicate'))
                } else {
                    this.nameError = []
                }
            })
        }
    },
    watch: {
        isValidForm(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.enterpriseDataForm) {
                this.$refs.enterpriseDataForm.resetValidation()
            }
        }
    }
}
